export const validateBookingForm = (form) => {
  const errors = {};
  
  if (!Array.isArray(form.vehicles) || form.vehicles.length === 0) {
    errors.vehicles = "At least one vehicle is required";
  } else {
    form.vehicles.forEach((vehicle, index) => {
      if (!vehicle.vehicleId) {
        errors[`vehicle_${index}_id`] = "Vehicle is required";
      } else if (!vehicle.packageId) {
        errors[`vehicle_${index}_packageId`] = "Package is required";
      }
    });
  }

  if (!form.fullName) errors.fullName = "Full name is required";
  if (!form.phoneNumber) {
    errors.phoneNumber = "Phone number is required";
  } else if (!/^\d+$/.test(form.phoneNumber)) {
    errors.phoneNumber = "Phone number must contain numbers only";
  } else if (form.phoneNumber.length > 11) {
    errors.phoneNumber = "Phone number must be at most 11 digits";
  }
  if (form.emergencyContactNumber && !/^\+?[0-9\-\s()]{7,20}$/.test(form.emergencyContactNumber)) {
    errors.emergencyContactNumber = "Please enter a valid emergency contact number";
  }
  if (form.cinc) {
    if (!/^\d+$/.test(form.cinc)) {
      errors.cinc = "CNIC must contain numbers only";
    } else if (form.cinc.length > 13) {
      errors.cinc = "CNIC must be at most 13 digits";
    }
  }
  if (!form.email) errors.email = "Email is required";
  if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
    errors.email = "Please enter a valid email";
  }
  if (!form.pickupLocation) errors.pickupLocation = "Pickup location is required";
  if (!form.dropoffLocation) errors.dropoffLocation = "Dropoff location is required";
  if (!form.pickupDateTime) errors.pickupDateTime = "Pickup date & time is required";
  if (!form.dropoffDateTime) errors.dropoffDateTime = "Dropoff date & time is required";

  // Validate that dropoff is after pickup
  if (form.pickupDateTime && form.dropoffDateTime) {
    const pickupDate = new Date(form.pickupDateTime);
    const dropoffDate = new Date(form.dropoffDateTime);
    if (dropoffDate <= pickupDate) {
      errors.dropoffDateTime = "Dropoff time must be after pickup time";
    }
  }

  return errors;
};

export const normalizeCustomersForForm = (data) => {
  if (Array.isArray(data)) return data;
  return data?.customers || data?.items || [];
};

export const normalizeVehiclesForForm = (data) => {
  if (Array.isArray(data)) return data;
  return data?.vehicles || data?.items || [];
};

export const formatCreateBookingPayload = (form) => {
  return {
    vehicles: form.vehicles.map((v) => ({
      vehicleId: v.vehicleId,
      packageId: v.packageId,
    })),
    fullName: form.fullName.trim(),
    companyName: form.companyName.trim(),
    phoneNumber: form.phoneNumber.trim(),
    emergencyContactNumber: form.emergencyContactNumber.trim(),
    cinc: form.cinc.trim(),
    email: form.email.trim().toLowerCase(),
    pickupLocation: form.pickupLocation.trim(),
    dropoffLocation: form.dropoffLocation.trim(),
    pickupDateTime: form.pickupDateTime,
    dropoffDateTime: form.dropoffDateTime,
  };
};
